import { FormRendererAPIType } from 'components/common/form';
import { SiblingTabType } from 'app/extreport/viewer/SiblingTabsMenu';

export interface IAiInsight {
    id: number;
    title: string;
    desc: string;
    isConditional: boolean;
}

export interface IFiltersFormProps {
    defaultData: any;
    formValues: any;
    elementId: number;
    segmentValueId: number;
    externalId: number;
    segmentData: Array<any>;
    setForm: (form: FormRendererAPIType) => void;
    hasFilters: boolean;
    multipleRefsLabel?: string;
    aiInsights: Array<IAiInsight>;
    tabsData: Array<SiblingTabType>;
    aiInsightsSelectionError?: boolean;
    alertRuleSelectionError?: boolean;
}

// CheckBoxList holds its value as a JSON string once mounted, but the defaults arrive as an array.
function parseSelectedAlertRules(value: Array<string | number> | string): Array<string> {
    if (Array.isArray(value)) {
        return value.map(String);
    }
    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (e) {
        return [];
    }
}

export function hasInvalidAlertRuleSelection(values: { [key: string]: any }): boolean {
    return (
        values?.only_include_when_alert_ind === 'Y' &&
        values?.send_for_alert_rule === 'selected' &&
        parseSelectedAlertRules(values?.selected_alert_rules ?? []).length === 0
    );
}
